import { MainLayout } from "~/components";
import { useEffect } from "react";
import Grid from "@mui/material/Grid";
import { makeStyles } from "@material-ui/core/styles";
import { HeroPage } from "./HeroPage";
import { height } from "@mui/system";
import { p1, p2, p3 } from "~/assets";
import Typography from "@mui/material/Typography";
import Box from "@material-ui/core/Box";

export const Partnersection = () => {
  const useStyles = makeStyles((theme) => ({
    logos:{
      height: 50,
      [theme.breakpoints.up('lg')]:{height: 120},
    },
    logo3:{
      height: 30,
      [theme.breakpoints.up('lg')]:{height: 80},
    }
  }));

  const classes = useStyles();
  return (
    <Box
      marginY={{xs:8, lg:15}}
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      id="partner"
      maxWidth="1440px"
      width="100%"
    >
      <Box marginBottom={{xs: 5, lg: 10}}>
        <Typography fontSize={{xs:'24px', lg: '40px'}} textAlign="center" variant="h6">
          Our Partners
        </Typography>
      </Box>
      <Box
        // marginLeft={"50px"}
        // sx={{ backgroundColor: "red" }}
        width="100%"
        // marginTop={5}
        display="flex"
        flexDirection={{ xs: "row", md: "row", lg: "row" }}
        justifyContent='space-evenly'
        alignItems="center"
      >

        <a href="https://edventure.vc">
          <img
            src={p1}
            alt="graph"
            className={classes.logos}
            width="auto"
            style={{ marginBottom: 20, marginTop: 20 }}
          />
        </a>

        <a href=" https://www.northeastgrowthhub.co.uk/toolkit/business-startup-toolkit ">
          <img
            style={{ marginBottom: 20, marginTop: 20 }}
            src={p2}
            alt="graph"
            className={classes.logos}
            width="auto"
          />
        </a>
        <a href="https://www.northeastgrowthhub.co.uk ">
          <img
            style={{ marginBottom: 20, marginTop: 20 }}
            src={p3}
            alt="graph"
            className={classes.logo3}
            width="auto"
          />
        </a>
      </Box>
    </Box>
  );
};
